export default "__VITE_ASSET__1gvhWU4r__"